import { doc, getDoc } from 'firebase/firestore';
import { CHAT_COLLECTION } from '../config/runtime';
import { auth, db } from './firebase';

async function isCanonicallyDeleted(chatId: string) {
  const snapshot = await getDoc(doc(db, CHAT_COLLECTION, chatId));
  return !snapshot.exists();
}

export const deleteChat = async (chatId: string) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Debes iniciar sesión para eliminar un chat.');
  const token = await user.getIdToken();
  try {
    const response = await fetch('/api/chat/delete', {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ chatId })
    });
    if (response.ok) return;
    if (response.status === 401 || response.status === 403) {
      throw new Error('No se pudo autorizar el borrado del chat.');
    }
  } catch (error) {
    try {
      if (await isCanonicallyDeleted(chatId)) return;
    } catch {
      // Preserve the original failure when Firestore cannot confirm deletion.
    }
    throw error;
  }

  try {
    if (await isCanonicallyDeleted(chatId)) return;
  } catch {
    // Fall through to the stable user-facing error.
  }
  throw new Error('No se pudo eliminar el chat.');
};
